import React from 'react'

function CustomTableRow ({ values }) {
  return (
    <>
      {values.map((value, index) => (
        <tr className='border-b border-gray-300'>
          {Object.keys(value).map((key, subIndex) => (
            <td
              key={`${index}-${subIndex}`}
              className='whitespace-nowrap !shadow-none px-2 py-2 text-sm text-gray-900'
            >
              {value[key] || ''}
            </td>
          ))}
        </tr>
      ))}
    </>
  )
}

export default CustomTableRow
